import { render } from "./AccountAddPage.vue?vue&type=template&id=6408e581&scoped=true"
import script from "./AccountAddPage.vue?vue&type=script&lang=js"
export * from "./AccountAddPage.vue?vue&type=script&lang=js"

import "./AccountAddPage.vue?vue&type=style&index=0&id=6408e581&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6408e581"]])

export default __exports__